// File: EasyStumpOut_PrivacyPolicy_v01.tsx
// Description: Privacy Policy page for EasyStumpOut.com using ReactSetv02026BSSC structure.
// Version: v01b - With A2P compliance 
// Created: 2026-04-14

import React from 'react';
import { Container } from 'react-bootstrap';

import EasyStumpOut_Header from "./EasyStumpOut_Header_v01_active";
import EasyStumpOut_Footer from "./EasyStumpOut_Footer_v01_active";
import { EASY_STUMP_OUT_LOCATION_DATA, ILocationConfig, Locations } from "../App_CONFIG_v01a";
import { InlinePageStyles } from '../App_STYLES_v01a';

// const locationConfig = EASY_STUMP_OUT_LOCATIONS[Locations.coloradoFrontRange];
// const locationName = locationConfig.websiteName;
type locationConfigProps = {
  locationConfig: ILocationConfig;
};




// const EasyStumpOut_PrivacyPolicy_v01: React.FC = ({locationConfig}: locationConfigProps) => {
const EasyStumpOut_PrivacyPolicy_v01: React.FC<locationConfigProps> = ({locationConfig}) => {

  return (
    <>
      <InlinePageStyles />
    <EasyStumpOut_Header locationConfig={locationConfig} />
    
    
    <main className="py-5">
      <Container style={{ maxWidth: '980px' }}>
        <section className="mb-4">
          <h1 className="fw-bold mb-3">Privacy Policy</h1>
          <p className="text-muted mb-2">Effective Date: April 14, 2026</p>
          <p>
            EasyStumpOut.com respects your privacy and is committed to protecting your personal
            information. This Privacy Policy explains how we collect, use, and safeguard your
            information when you visit our website, request a quote, or use our services.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">1. Information We Collect</h2>
          <p>We may collect the following types of information:</p>
          <ul>
            <li>Contact Information (name, phone number, email address)</li>
            <li>Property Information (service address, site details, photos if provided)</li>
            <li>Service Requests and Communication History</li>
            <li>Technical Data (IP address, browser type, device info)</li>
            <li>Website Usage Data (pages visited, time on site, interactions)</li>
            <li>SMS Consent Data (opt-in status, consent timestamp, and communication preferences)</li>

          </ul>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">2. How We Use Your Information</h2>
          <ul>
            <li>Provide quotes and schedule stump removal services</li>
            <li>Communicate about your request or project</li>
            <li>Improve our website and services</li>
            <li>Send service-related updates or notifications</li>
            <li>Send SMS messages for service-related communications where consent has been provided</li>
            <li>Comply with legal obligations</li>
            
          </ul>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">3. Sharing of Information</h2>
          <p>
            We do not share, sell, rent, or disclose your mobile phone number or SMS consent data
            to third parties for marketing or promotional purposes.
          </p>

          <p>
            We may share information with:
          </p>
          <ul>
            {/* <li>Service providers and contractors assisting with operations</li> */}
            <li>Payment processors (if applicable)</li>
            <li>Legal or regulatory authorities when required</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">4. Cookies and Tracking</h2>
          <p>
            Our website may use cookies or similar technologies to enhance user experience,
            analyze traffic, and improve functionality. You can control cookie settings
            through your browser preferences.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">5. Data Security</h2>
          <p>
            We implement reasonable safeguards to protect your information. However, no method
            of transmission over the internet is 100% secure.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">6. Your Rights</h2>
          <p>
            Depending on your location, you may have rights regarding your personal data,
            including access, correction, or deletion. To make a request, contact us using
            the information on our website.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">7. Third-Party Links</h2>
          <p>
            Our website may contain links to third-party websites. We are not responsible for
            their privacy practices.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">8. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Changes will be posted on this
            page with an updated effective date.
          </p>
        </section>

        <section>
          <h2 className="h4 fw-semibold mb-3">9. Contact Information</h2>
          <p>
            If you have questions about this Privacy Policy, please contact EasyStumpOut.com
            through the contact details provided on the website.
          </p>
        </section>


        <section className="mb-4">
          <h2 className="h4 fw-semibold mb-3">10. SMS Communications and Consent</h2>
          <p>
            If you provide your mobile phone number and opt in to receive SMS communications,
            you consent to receive text messages from EasyStumpOut.com related to your service
            requests, scheduling, updates, and customer support.
          </p>
          <p>
            Message frequency may vary. Standard message and data rates may apply depending on
            your carrier and mobile plan.
          </p>
          <p>
            You may opt out of SMS messages at any time by replying STOP to any message.
            For assistance, reply HELP or contact us through the website.
          </p>
          <p>
            SMS consent is not a condition of purchase.
          </p>
          <p>
            We retain SMS consent records, including opt-in status and timestamps, for
            compliance and customer service purposes.
          </p>
        </section>

      </Container>
    </main>

    <EasyStumpOut_Footer locationConfig={locationConfig} />
  </>

  );
};

export default EasyStumpOut_PrivacyPolicy_v01;

// End of File: EasyStumpOut_PrivacyPolicy_v01.tsx
// Description: Privacy Policy page for EasyStumpOut.com
// Version: v01
// Last Updated: 2026-04-14
